import React, { useState } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import './App.css';

const BOT_URL = process.env.REACT_APP_BOT_URL || 'http://localhost:8080';

export default function App() {
  const [authed, setAuthed] = useState(() => sessionStorage.getItem('eco_admin') === 'true');

  const handleLogin = async (pw) => {
    try {
      const res = await fetch(`${BOT_URL}/api/verify-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password: pw })
      });
      const data = await res.json();
      if (res.status === 200 && data.success) {
        sessionStorage.setItem('eco_admin', 'true');
        sessionStorage.setItem('eco_admin_pw', pw);
        setAuthed(true);
        return true;
      }
    } catch (e) {
      console.error('Verify password request failed:', e);
    }
    return false;
  };

  const handleLogout = () => {
    sessionStorage.removeItem('eco_admin');
    sessionStorage.removeItem('eco_admin_pw');
    setAuthed(false);
  };

  return authed ? (
    <Dashboard onLogout={handleLogout} />
  ) : (
    <Login onLogin={handleLogin} />
  );
}

